// extracted by mini-css-extract-plugin
export default {"table_container":"TableMainResults_table_container__vicOX","main_table":"TableMainResults_main_table__lkmVZ","tabmain_tablele":"TableMainResults_tabmain_tablele__ou4eO"};